/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef, useEffect } from 'react';
import { isIOS } from 'react-device-detect';
import { PannellumVideo } from 'pannellum-react';
import videojs from 'video.js';

import LinkBraun from '../common/LinkBraun';
import HeaderBraun from '../common/HeaderBraun';
import { THEME } from '../config/constants';

import translations from '../data';

import 'videojs-vr/dist/videojs-vr.min.js';
import '../../../../node_modules/video.js/dist/video-js.min.css';

import styles from './styles.module.css';

const { general } = translations;

const SkipVideo = ({ showNext }) => {
  const videoRef = useRef(null);
  const _isMobileIos =
    isIOS && typeof window !== 'undefined' && window.innerWidth < 1024;

  useEffect(() => {
    if (_isMobileIos) {
      const player = videojs(videoRef.current, {
        controls: false,
        fluid: false,
        fill: true,
      });

      player.vr({ projection: 'equirectangular' });
    }
  }, [_isMobileIos]);

  return (
    <>
      <HeaderBraun theme={THEME.WHITE} />
      <div className={styles.link}>
        <LinkBraun
          onClick={() => {
            showNext();
          }}
          text={general.skipIntro}
          blackBorder
        />
      </div>
      <div className={styles.liveStream}>
        {_isMobileIos && (
          <div data-vjs-player>
            <video
              ref={videoRef}
              playsInline
              className="video-js"
              crossOrigin="anonymous"
              autoPlay
            >
              <source
                src="https://res.cloudinary.com/arts/video/upload/v1600430502/max-braun/intro/Braun360_FullEdit_v021_2560x1440_H264_with_movcontainer_injected.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        )}
        {/* not iOS */}
        {!_isMobileIos && (
          <PannellumVideo
            video="https://res.cloudinary.com/arts/video/upload/v1600430502/max-braun/intro/Braun360_FullEdit_v021_2560x1440_H264_with_movcontainer_injected.mp4"
            width="100%"
            height="100%"
            pitch={0}
            yaw={0}
            hfov={120} // desktop: 120, mobile: 100
            minHfov={50}
            maxHfov={180}
            compass
            keyboardZoom={false}
            mouseZoom={false}
            autoPlay
            autoLoad
            muted={false}
            orientationOnByDefault
            showFullscreenCtrl={false}
            showControls={false}
          />
        )}
      </div>
    </>
  );
};

export default SkipVideo;
